export const rem = (pixels: number) => {
  if(!pixels) return '';

  return `${pixels/16}rem`;
}
